import { render } from "./AddProducts.vue?vue&type=template&id=22abbae2&scoped=true"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"

import "./AddProducts.vue?vue&type=style&index=0&id=22abbae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22abbae2"]])

export default __exports__